import { CONST } from "../../CONST";
import { Shape } from "./Shape";

export interface BlockConfig {
   gridOffset: {x: integer, y: integer}, //Offset from shape base
}

const CONFIG = {
   invalidBlockColor: CONST.GRID_FILL.BLOCK_GREY,
   defaultDepth: 20,
   dragDepth: 21,

   moveTween: {
      duration: 100,
      spawnDuration: 300,
      ease: "Back.easeOut",
   },

   fadeTween: {
      duration: 500,
      delay: 100,
      ease: "Quad.easeInOut",
   }
}

export class Block extends Phaser.GameObjects.Image {
   public config: BlockConfig;

   private gridOrigin: Phaser.Math.Vector2;
   private cellSize: number;
   private shape: Shape;

   private startX!: number;
   private startY!: number;

   private gridPos !: {x: number, y: number};

   private gameLost = false;


   constructor(config: BlockConfig, shape: Shape, scene: Phaser.Scene, gridOrigin: Phaser.Math.Vector2, cellSize: number){
      super(scene, scene.game.renderer.width/2, scene.game.renderer.height + 200, CONST.BUTTONS.BACK);

      this.config = config;
      this.gridOrigin = gridOrigin;
      this.cellSize = cellSize;
      this.shape = shape;

      this.setDepth(CONFIG.defaultDepth);
      this.setDisplaySize(this.cellSize+1, this.cellSize);
      this.setInteractive({useHandCursor: true, draggable: true});

      this.on('dragstart', (pointer: any, dragX: number, dragY: number) => {
         this.shape.handleDragStart(this.x, this.y);
      });
 
      this.on('drag', (pointer: any, dragX: number, dragY: number) => {
         if (this.gameLost) return;
         this.shape.handleDrag(dragX, dragY);
     });

     this.on('dragend', (pointer: any, dragX: number, dragY: number, dropped: boolean) => {
        if (this.gameLost) return;
         this.shape.handleDragEnd();
     });

     scene.add.existing(this);
   }

   public handleDragStart(){
      this.depth = CONFIG.dragDepth;

      this.startX = this.x;
      this.startY = this.y;
   }

   public updateDragPosition(xDiff: number, yDiff: number){
      this.x = this.startX + xDiff;
      this.y = this.startY + yDiff;
   }

   public setGridPosition(shapeGridPos: {x: integer, y: integer}, isSpawn: boolean = false){
      this.depth = CONFIG.defaultDepth;

      this.gridPos = {
         x: this.config.gridOffset.x + shapeGridPos.x, 
         y: this.config.gridOffset.y + shapeGridPos.y
      };

      let worldPos = this.getWorldPos(this.gridPos);
     
      this.shape.scene.tweens.add({
         targets: this,
         x: worldPos.x,
         y: worldPos.y,
         ease: CONFIG.moveTween.ease,
         duration: isSpawn ? CONFIG.moveTween.spawnDuration : CONFIG.moveTween.duration,
      });
      return this;
   }

   private getWorldPos(gridPos: {x: number, y: number}){
      return {x: this.gridOrigin.x + this.cellSize * (gridPos.x + 0.5),
      y: this.gridOrigin.y + this.cellSize * (gridPos.y + 0.5)}
   }

   public fadeOut(){
      this.disableInteractive();

      let worldPos = this.getWorldPos(this.gridPos);
      var img = this.shape.scene.add.image(worldPos.x, worldPos.y, CONFIG.invalidBlockColor)
      .setDepth(CONFIG.dragDepth+1)
      .setScale(this.scaleX, this.scaleY)
      .setAlpha(1)
      .setTintFill(0xffffff);

      this.shape.scene.tweens.add({
         targets: img,
         alpha: 0,
         ease: CONFIG.fadeTween.ease,
         duration: CONFIG.fadeTween.duration,
         delay: CONFIG.fadeTween.delay,
         onComplete: () => {
            img.destroy();
         }
      });
   }

   public onGameLost(){
      this.disableInteractive();
      this.gameLost = true;
   }

   public setHighlight(valid : boolean){
      this.setTexture( valid ? this.shape.getBlockColor() : CONFIG.invalidBlockColor);
   }

   public getGridPos(){
      return this.gridPos;
   }
}